import React from 'react';

function Value(props) {
  return <span className="value">{props.value}</span>;
}

export default Value;
